module.exports = __webpack_public_path__ + "compile.html"


/*****************
 ** WEBPACK FOOTER
 ** ./compile.html
 ** module id = 11
 ** module chunks = 0
 **/